export const icons: { [key: string]: string } = {
  subscribe_tg: 'tg.svg',
  subscribe_x: 'x.svg'
}

export const labels: { [key: string]: string } = {
  subscribe_tg: 'Follow Leea on Telegram!',
  subscribe_x: 'Follow Leea on X!'
}
